<template>
    <div class="IperMatrizPeligrosOpcionesControlCambiosEditarControl">
        <div class="modal fade" :id="'editarControlCambios' + idControlCambio" tabindex="-1"
            :aria-labelledby="'editarControlCambios' + idControlCambio" aria-hidden="true">
            <div class="modal-dialog modal-xl">
                <div class="modal-content bg-light">
                    <div class="modal-header">
                        <h5 class="modal-title dato" :id="'editarControlCambios' + idControlCambio">
                            Editar Control de Cambios
                        </h5>
                        <button class="close" data-dismiss="modal" type="button" aria-label="Close"
                            @click="$emit('controlCambioEditado', false);">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-3">
                                <label class="color_letra mb-4">Tipo de Cambio: * </label>
                                <select class="form-control form-control-sm boton_texto"
                                    v-model="controlCambioMatriz.controlCambios.tipoCambio">
                                    <option disabled selected>Seleccione...</option>
                                    <option value="Elaboración">Elaboración</option>
                                    <option value="Actualizacción">Actualizacción</option>
                                </select>
                            </div>
                            <div class="col-md-3">
                                <label class="color_letra mb-4">Fecha: * </label>
                                <input class="form-control form-control-sm boton_texto" v-model="fechaCambio" type="date" />
                            </div>
                            <div class="col-md-6">
                                <label class="color_letra">Observación:</label>
                                <textarea class="form-control form-control-sm boton_texto" v-model="
                                    controlCambioMatriz.controlCambios.observacionCambio
                                " placeholder="Observación." autocomplete="on"></textarea>
                            </div>
                            <div class="col-md-12">
                                <br />
                                <button class="btn btn-form" data-dismiss="modal" type="submit" @click="
                                    editarControlCambio(idControlCambio)" style="width: 200px;">
                                    Guardar
                                </button>
                                <button class="btn btn-dark btn-sm rounded-pill" data-dismiss="modal" type="button"
                                    style="width: 200px; font-size: 9.5pt;" @click="$emit('controlCambioEditado', false);">
                                    Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { firebase, db } from '@/firebase';
import moment from 'moment';
import Swal from 'sweetalert2';
export default {
    name: "IperMatrizPeligrosOpcionesControlCambiosEditarControl",

    props: {
        idEmpresa: String,
        idControlCambio: String
    },

    data() {
        return {
            controlCambioMatriz: {
                controlCambios: {
                    idControlCambio: this.idControlCambio,
                    tipoCambio: "",
                    fechaCambio: "",
                    observacionCambio: "",
                },
                registro: {
                    creacion: firebase.firestore.FieldValue.serverTimestamp(),
                },
            },
            fechaCambio: "",
        }
    },

    async created() {
        this.$isLoading(true)
        await this.obtenerControlCambio()
        this.$isLoading(false)
    },

    methods: {
        async obtenerControlCambio() {
            let q = "cliente_empresa/" + this.idEmpresa + "/controlcambios";
            await db.collection(q).doc(this.idControlCambio).get().then((doc) => {
                let fechaControl = doc.data().controlCambios.fechaCambio.toDate();
                fechaControl = moment(fechaControl).format("YYYY-MM-DD");
                if (doc.exists) {
                    this.controlCambioMatriz.controlCambios.tipoCambio = doc.data().controlCambios.tipoCambio;
                    this.fechaCambio = fechaControl;
                    this.controlCambioMatriz.controlCambios.observacionCambio = doc.data().controlCambios.observacionCambio;
                }
            });
        },

        async editarControlCambio(id) {
            this.fechaCambio = this.fechaCambio.split("-");
            var fechaEditada = new Date(
                this.fechaCambio[0],
                this.fechaCambio[1] - 1,
                this.fechaCambio[2]
            );
            this.controlCambioMatriz.controlCambios.fechaCambio = fechaEditada;
            $("#editarControlCambios" + id).modal("hide");
            let q = "cliente_empresa/" + this.idEmpresa + "/controlcambios";
            await db.collection(q).doc(id).set(this.controlCambioMatriz)
            Swal.fire({
                position: "center",
                icon: "success",
                title: "Datos editados correctamente.",
                showConfirmButton: false,
                timer: 1500,
            });
            this.$emit("controlCambioEditado", true);
        }
    }
}
</script>

<style scoped></style>